// Angular Imports
import { NgModule } from "@angular/core";

// This Module's Components
import { ExamscheduleComponent } from "./examschedule.component";
import { BrowserModule } from "@angular/platform-browser";
import { ReportViewerModule } from "src/app/report-viewer/report-viewer.module";
import { FormsModule } from "@angular/forms";
import { NgxErrorsModule } from "@ultimate/ngxerrors";
import { ReactiveFormsModule } from "@angular/forms";
import { LovService } from "src/app/Shared/lov.service";
import { SMAcademicYearService } from "src/app/Shared/smacademicyear.service";
import { SMCourseService } from "src/app/Shared/smcourse.service";
import { InstituteService } from "src/app/Shared/institute.service";
import { ComponentModule } from "src/app/components/component.module";
import { IxsReportModule } from "src/app/components/ixs-report/ixs-report.module";

@NgModule({
  imports: [
    BrowserModule,
    ReportViewerModule,
    NgxErrorsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentModule,
    IxsReportModule
  ],
  declarations: [ExamscheduleComponent],
  exports: [ExamscheduleComponent],
  providers: [
    LovService,
    SMAcademicYearService,
    SMCourseService,
    InstituteService
  ]
})
export class ExamscheduleModule {}
